<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <button
        type="button"
        class="ac-close-button"
        @click="toggle(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="ac-header">
        Disconnect Slack Integration
      </div>
    </div>
    <div class="ac-body-container">
      Are you sure you want to disconnect the Slack integration?
      This action will stop all notifications and remove
      the integration from your SmartAC.com.
    </div>
    <div class="disc-footer-container">
      <div class="ac-footer-sub">
        <button
          type="button"
          class="ac-form-cancel"
          @click="toggle(false)"
        >
          Cancel
        </button>
        <button
          type="button"
          class="ac-form-disconnect"
          @click="disconnect"
        >
          Disconnect
        </button>
      </div>
    </div>
    <ProcessOverlay
      :show="processing"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'DisconnectConfirm',
  components: {
    ProcessOverlay,
  },
  props: {
    toggle: Function,
    update: Function,
    partnerSettings: Object,
    changeStateValue: Function,
  },
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    async disconnect() {
      this.processing = true;
      try {
        await this.update({
          SLACK_LEAD_CHANNEL: '',
          SLACK_SERVICE_CHANNEL: '',
          SLACK_SYSTEM_CHANNEL: '',
          SLACK_HOMEOWNER_CHANNEL: '',
          SLACK_ACCESS_TOKEN: '',
        });
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          message: 'There was an unexpected error updating setting. Please try again or contact support',
        });
      }
      this.processing = false;
      this.toggle(false);
    },
  },
};
</script>

<style lang="scss" scoped>

.disc-footer-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;

  .ac-footer-sub {
    display: flex;
    justify-content: space-between;
    gap: 15px;

    .ac-form-disconnect {
      border-radius: 6px;
      color: white;
      background-color: $TOMATO100;
      font-weight: 600;
      border: 2px solid $TOMATO100;
      padding: 12px 24px;
      height: 48px;
      width: 100%;
    }

    .ac-form-cancel {
      border-radius: 6px;
      color: $PRIMARY;
      background-color: white;
      font-weight: 600;
      border: 2px solid $PRIMARY;
      padding: 12px 24px;
      height: 48px;
      width: 100%;
    }
  }
}
</style>
